"use client";

import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register ScrollTrigger
if (typeof window !== "undefined") {
    gsap.registerPlugin(ScrollTrigger);
}

const STATS = [
    { value: 15, suffix: "+", label: "Years Experience" },
    { value: 500, suffix: "+", label: "Projects Completed" },
    { value: 200, suffix: "+", label: "Happy Clients" },
    { value: 24, suffix: "/7", label: "Support Available" },
];

export function StatsSection() {
    const sectionRef = useRef<HTMLElement>(null);

    useGSAP(() => {
        const stats = gsap.utils.toArray(".stat-value") as HTMLElement[];

        stats.forEach((stat, i) => {
            const target = STATS[i];

            gsap.fromTo(stat,
                { textContent: "0" },
                {
                    textContent: target.value,
                    duration: 2.5,
                    ease: "power2.out",
                    snap: { textContent: 1 },
                    immediateRender: false,
                    scrollTrigger: {
                        trigger: sectionRef.current,
                        start: "top 80%",
                        toggleActions: "play none none reverse"
                    },
                    onUpdate: function () {
                        stat.innerHTML = Math.ceil(Number(this.targets()[0].textContent)) + target.suffix;
                    }
                }
            );
        });

        gsap.from(".stat-label", {
            y: 20,
            opacity: 0,
            duration: 0.8,
            stagger: 0.2,
            scrollTrigger: {
                trigger: sectionRef.current,
                start: "top 80%",
            }
        });

    }, { scope: sectionRef });

    return (
        <section ref={sectionRef} className="relative py-20 bg-fixed bg-cover bg-center bg-no-repeat" style={{ backgroundImage: "url('/images/hero/slide-2.webp')" }}>
            <div className="absolute inset-0 bg-[#001746]/85"></div>
            <div className="container mx-auto px-4 relative z-10">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x divide-white/10">
                    {STATS.map((stat, index) => (
                        <div key={index} className="p-4">
                            <div className="text-4xl md:text-5xl font-bold text-white mb-2 font-serif">
                                <span className="stat-value">{stat.value}{stat.suffix}</span>
                            </div>
                            <div className="stat-label text-blue-200 text-sm md:text-base font-medium uppercase tracking-wider">{stat.label}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
